import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonsModule } from "../../commons/angular/commons.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { NgxPermissionsModule } from "ngx-permissions";
import {
  BzButton,
  BzCheckbox,
  BzDatePicker,
  BzDialogLayout,
  BzDivider,
  BzEmptyState,
  BzFormField,
  BzIcon,
  BzInput,
  BzMenu,
  BzProgress,
  BzRadio,
  BzRadioGroup,
  BzSearchInput,
  BzSelect,
  BzSpinner,
  BzSwitch,
  BzTable,
  BzTableHeaderDef,
  BzTableRowDef,
  BzTag,
  BzTooltip
} from "@bringoz/ui";
import { TimecardStatusTonePipe } from "./pipes/timecard-status-tone.pipe";
import { agentConfigurationProfilesRequestsServiceProvider } from "../../../providers";
import { TimecardsTableComponent } from "./components/timecards-table/timecards-table.component";
import { TimecardTableRowComponent } from "./components/timecard-table-row/timecard-table-row.component";
import { TimecardEntryRowComponent } from "./components/timecard-entry-row/timecard-entry-row.component";
import { TimecardStatusTooltipComponent } from "./components/timecard-status-tooltip/timecard-status-tooltip.component";
import { TimekeepingViewComponent } from "./components/timekeeping-view/timekeeping-view.component";
import { TimekeepingTotalsComponent } from "./components/timekeeping-totals/timekeeping-totals.component";
import { TimekeepingToolbarComponent } from "./components/timekeeping-toolbar/timekeeping-toolbar.component";
import { CustomSelectFilterComponent } from "./components/custom-select-filter/custom-select-filter.component";
import {
  CustomSelectFilterPanelComponent
} from "./components/custom-select-filter-panel/custom-select-filter-panel.component";
import {
  TimekeepingColumnsSettingsPanelComponent
} from "./components/timekeeping-columns-settings-panel/timekeeping-columns-settings-panel.component";
import { TimecardDetailComponent } from "./components/timecard-detail/timecard-detail.component";
import { TimecardDetailHeaderComponent } from "./components/timecard-detail-header/timecard-detail-header.component";
import { TimecardDetailSummaryComponent } from "./components/timecard-detail-summary/timecard-detail-summary.component";
import { TimecardShiftListComponent } from "./components/timecard-shift-list/timecard-shift-list.component";
import { TimecardEditEntryPanelComponent } from "./components/timecard-edit-entry-panel/timecard-edit-entry-panel.component";
import { TimecardAdminTimeDialogComponent } from "./components/timecard-admin-time-dialog/timecard-admin-time-dialog.component";
import { TimecardAddStopDialogComponent } from "./components/timecard-add-stop-dialog/timecard-add-stop-dialog.component";
import { TimecardDateTimeFieldComponent } from "./components/timecard-date-time-field/timecard-date-time-field.component";
import {
  TimecardAccountSelectPanelComponent
} from "./components/timecard-account-select-panel/timecard-account-select-panel.component";
import {
  TimecardHistoryLogDialogComponent
} from "./components/timecard-history-log-dialog/timecard-history-log-dialog.component";
import {
  TimekeepingExportPayrollDialogComponent
} from "./components/timekeeping-export-payroll-dialog/timekeeping-export-payroll-dialog.component";
import {
  TimekeepingMondelezSummaryDialogComponent
} from "./components/timekeeping-mondelez-summary-dialog/timekeeping-mondelez-summary-dialog.component";
import {
  TimekeepingPayrollRecoveryDialogComponent
} from "./components/timekeeping-payroll-recovery-dialog/timekeeping-payroll-recovery-dialog.component";

/**
 * Imported by AppModule rather than bootstrapped on its own: the timekeeping components are downgraded
 * through downgradedAppModule, so they share its injector and the i18n dictionary TranslationsService fills.
 */
@NgModule({
  declarations: [
    TimekeepingViewComponent,
    TimekeepingTotalsComponent,
    TimekeepingToolbarComponent,
    CustomSelectFilterComponent,
    CustomSelectFilterPanelComponent,
    TimekeepingColumnsSettingsPanelComponent,
    TimecardsTableComponent,
    TimecardTableRowComponent,
    TimecardEntryRowComponent,
    TimecardStatusTooltipComponent,
    TimecardDetailComponent,
    TimecardDetailHeaderComponent,
    TimecardDetailSummaryComponent,
    TimecardShiftListComponent,
    TimecardEditEntryPanelComponent,
    TimecardAdminTimeDialogComponent,
    TimecardAddStopDialogComponent,
    TimecardDateTimeFieldComponent,
    TimecardAccountSelectPanelComponent,
    TimecardHistoryLogDialogComponent,
    TimekeepingExportPayrollDialogComponent,
    TimekeepingMondelezSummaryDialogComponent,
    TimekeepingPayrollRecoveryDialogComponent,
    TimecardStatusTonePipe
  ],
  imports: [
    CommonModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    BzButton,
    BzCheckbox,
    BzDatePicker,
    BzDialogLayout,
    BzDivider,
    BzEmptyState,
    BzFormField,
    BzIcon,
    BzInput,
    BzMenu,
    BzProgress,
    BzRadio,
    BzRadioGroup,
    BzSearchInput,
    BzSelect,
    BzSpinner,
    BzSwitch,
    BzTable,
    BzTableHeaderDef,
    BzTableRowDef,
    BzTag,
    BzTooltip
  ],
  providers: [
    agentConfigurationProfilesRequestsServiceProvider
  ],
  exports: [
    TimekeepingViewComponent,
    TimecardDetailComponent
  ]
})
export class TimekeepingAngularModule {
}
